import { render, staticRenderFns } from "./UserLearnProgressTable.vue?vue&type=template&id=284ed25d&"
import script from "./UserLearnProgressTable.vue?vue&type=script&lang=js&"
export * from "./UserLearnProgressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports